import { render, staticRenderFns } from "./ShibouDoukishoEdit.vue?vue&type=template&id=73f0af8d&scoped=true"
import script from "./ShibouDoukishoEdit.vue?vue&type=script&lang=js"
export * from "./ShibouDoukishoEdit.vue?vue&type=script&lang=js"
import style0 from "./ShibouDoukishoEdit.vue?vue&type=style&index=0&id=73f0af8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f0af8d",
  null
  
)

export default component.exports